// extracted by mini-css-extract-plugin
module.exports = {"top-message":"top-message-f62b092b9a05a47e48b36e7727e920c9"};